'use client';

import { type ReactNode } from 'react';

import { blue, slate } from '@/lib/colours';

import { CheckCircleIcon, StepActiveIcon } from '@/components/icons';
import {
  Box,
  type BoxProps,
  Radio,
  RadioProps,
  Typography,
} from '@/primitives';

export interface SectionTabProps {
  title: ReactNode;
  subTitle: ReactNode;
  value?: RadioProps['value'];
  checked?: RadioProps['checked'];
  completed?: boolean;
  sx?: BoxProps['sx'];
}

export function SectionTab({
  title,
  subTitle,
  value,
  checked,
  completed,
  sx,
}: SectionTabProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: '10px',
        borderRadius: '100px',
        padding: '12px 16px',
        ':has(input:checked)': {
          backgroundColor: blue[50],
        },
        ...sx,
      }}
    >
      {completed ? (
        <CheckCircleIcon sx={{ margin: '9px', color: blue[500] }} />
      ) : (
        <Radio
          value={value}
          checked={checked}
          checkedIcon={<StepActiveIcon />}
        />
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Typography variant="bodymedium" color={slate[900]}>
          {title}
        </Typography>
        <Typography variant="bodymedium" color={slate[500]}>
          {subTitle}
        </Typography>
      </Box>
    </Box>
  );
}
